import { Button } from 'shared/theme/elements';
import { ModalBody, ModalCard, ModalFoot, ModalIc, ModalTitle, ModalWrap } from '../ProgramSetup.styled';

interface Props {
  open: boolean;
  title?: string;
  bodyText: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmModal = ({
  open,
  title = 'Delete this program setup?',
  bodyText,
  loading,
  onCancel,
  onConfirm,
}: Props) => {
  if (!open) return null;

  return (
    <ModalWrap className="ps-redesign" role="dialog" aria-modal="true" onClick={onCancel}>
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <ModalIc>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" />
            <path d="M10 11v6M14 11v6" />
          </svg>
        </ModalIc>
        <ModalTitle>{title}</ModalTitle>
        <ModalBody>{bodyText}</ModalBody>
        <ModalFoot>
          <Button variant="outlined" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} loading={loading}>
            Delete
          </Button>
        </ModalFoot>
      </ModalCard>
    </ModalWrap>
  );
};
